var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3093 21C10.4848 21.304 10.7373 21.5565 11.0413 21.732C11.3453 21.9075 11.6902 21.9999 12.0413 21.9999C12.3923 21.9999 12.7372 21.9075 13.0412 21.732C13.3452 21.5565 13.5977 21.304 13.7733 21M3.30326 15.326C3.17263 15.4692 3.08642 15.6472 3.05512 15.8385C3.02382 16.0298 3.04878 16.226 3.12697 16.4034C3.20516 16.5807 3.3332 16.7316 3.49552 16.8375C3.65784 16.9434 3.84744 16.9999 4.04126 17H20.0413C20.2351 17.0001 20.4247 16.9438 20.5871 16.8381C20.7496 16.7324 20.8778 16.5817 20.9562 16.4045C21.0345 16.2273 21.0598 16.0311 21.0287 15.8398C20.9977 15.6485 20.9117 15.4703 20.7813 15.327C19.4513 13.956 18.0413 12.499 18.0413 8C18.0413 6.4087 17.4091 4.88258 16.2839 3.75736C15.1587 2.63214 13.6326 2 12.0413 2C10.45 2 8.92384 2.63214 7.79862 3.75736C6.6734 4.88258 6.04126 6.4087 6.04126 8C6.04126 12.499 4.63026 13.956 3.30326 15.326Z",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.e5ccad1eb40000e1f3e5379604951496.svg";
export { ForwardRef as ReactComponent };